import { Sidebar } from "primereact/sidebar";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrwcBasicButton from "../buttons/PrwcBasicButton";
import "./PrwcSidebar.scss";

const PrwcSidebar = (props: any) => {
  const {
    isSideBarVisible,
    headerTitle,
    position = "right",
    showCloseIcon = false,
    className,
    enableFullScreen = false,
    onHide,
    dismissable = false,
    headerButtons,
  } = props;
  const { t } = useTranslation();

  const [isFullScreenExpand, setIsFullScreenExpand] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreenExpand((v) => !v);
  };

  const handleOnHide = () => {
    onHide(false);
    // setIsFullScreenExpand(false);
  };

  return (
    <div>
      <Sidebar
        visible={isSideBarVisible}
        fullScreen={isFullScreenExpand}
        position={position}
        className={`${isFullScreenExpand ? null : className} p-0`}
        showCloseIcon={showCloseIcon}
        onHide={handleOnHide}
        blockScroll={true}
        dismissable={dismissable}
      >
        <div className="flex items-center justify-between px-4 border-b h-14">
          <div className="text-xl">{headerTitle}</div>
          <div className="flex">
            {headerButtons && headerButtons()}
            {enableFullScreen ? (
              !isFullScreenExpand ? (
                <PrwcBasicButton
                  icon="pi pi-window-maximize"
                  onClick={toggleFullScreen}
                  className="p-button-rounded p-button-text p-button-secondary"
                  tooltipText={t("generic.action.fullScreen")}
                />
              ) : (
                <PrwcBasicButton
                  icon="pi pi-window-minimize"
                  onClick={toggleFullScreen}
                  className="p-button-rounded p-button-text p-button-secondary"
                  tooltipText={t("generic.action.smallScreen")}
                />
              )
            ) : null}
            <PrwcBasicButton
              icon="pi pi-times"
              onClick={onHide}
              className="p-button-rounded p-button-text p-button-secondary"
              tooltipText={t("generic.action.close")}
            />
          </div>
        </div>
        <div className="h-screen">{props.children}</div>
      </Sidebar>
    </div>
  );
};

export default PrwcSidebar;
